(function (w, d, ps) {

    const assetId = '~/Controls/MsForm/Feedback_recaptcha.min.js';

    if (!w.umwAssets || !w.umwAssets[assetId]) {
        console.error('No context found for ' + assetId);
        return;
    }

    w.recaptcha_load();

    for (let ctx of w.umwAssets[assetId]) {
        
        let captchaWidgetId;
        const btnSend = d.getElementById(ctx.btnSendId);
        const hRecaptcha2Result = d.getElementById(ctx.hRecaptcha2ResultId);

        ps.subscribe('recaptcha.callback.loaded', function() {
            captchaWidgetId = w.grecaptcha.render(ctx.divRecaptcha2Id, {
                'sitekey': ctx.recaptcha2SiteKey,
                'theme': ctx.recaptchaTheme,
                'size': ctx.recaptchaSize
            });
        });

        btnSend.onclick = _ => {
            var captchaResponse = w.grecaptcha.getResponse(captchaWidgetId);
            hRecaptcha2Result.value = captchaResponse;
            return true;
        };
    }
})(window, document, window.PubSub);